module.exports = __webpack_public_path__ + "img/17.7c2b8c4c.png";